import React, { FC } from 'react';

import Bounty from 'react-bounty';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { getLoyaltyPointsfromKey } from 'components/roll-up-the-rim/helpers';
import { useLoyaltyActiveCard } from 'hooks/loyalty/use-loyalty-active-card';

import { DARK_BRAND_COLOR } from '../gameplay-background/gameplay-background';

const Container = styled.div`
  text-align: center;
  margin: auto;
`;
const Header = styled.p`
  font-weight: ${Styles.fontWeight.heavy};
`;
const Content = styled.div`
  background-color: ${DARK_BRAND_COLOR};
  border-radius: 0.5rem;
  .counter {
    font-size: 4rem;
    font-weight: bolder;
    fill: ${Styles.color.white};
    height: 6rem;
  }
`;
const Footer = styled.p`
  font-weight: bold;
  font-size: 1.2rem;
`;

interface GameplayRewardsPointsProps {
  rewardKey: string;
}

interface GameplayRewardsPointsViewProps {
  headerText: string;
  footerText: string;
  points: number;
}

export const GameplayRewardsPoints: FC<GameplayRewardsPointsProps> = ({ rewardKey }) => {
  const { formatMessage } = useIntl();
  const { loyaltyDetails } = useLoyaltyActiveCard();
  const points = getLoyaltyPointsfromKey(rewardKey);
  const headerText = formatMessage({ id: 'rutrYouHave' });
  const footerText = formatMessage({ id: 'rutrRewardsPoints' });
  return (
    <GameplayRewardsPointsView
      headerText={headerText}
      footerText={footerText}
      points={(loyaltyDetails?.points || 0) + points}
    />
  );
};

export const GameplayRewardsPointsView: FC<GameplayRewardsPointsViewProps> = ({
  headerText,
  footerText,
  points,
}) => {
  return (
    <Container>
      <Header>{headerText}</Header>
      <Content>
        <Bounty value={points} className="counter" />
      </Content>
      <Footer>{footerText}</Footer>
    </Container>
  );
};
